export const baseURL = "https://roulette.egchat.live/";
export const adminBaseURL = "https://admin.egchat.live/";
export const key = "8{vWkyP/zyJne9s";
